











import { Component, Watch } from 'vue-property-decorator';
import { PaginationMixin } from '@/utils/mixin';
import templateOrdinary from './templateOrdinary.vue';
import templateCustom from './templateCustom.vue';
import templateThird from './templateThird.vue';

const ROUTE_NAME_TO_TAB = {
    rg_template_custom: 'custom',
    rg_template_third: 'third',
    rg_template_ordinary: 'ordinary'
};

/**
 * rg模板列表
 *
 * @author  liyuyao
 * @date 03/11/2020
 */
@Component({
    components: {
        templateOrdinary,
        templateCustom,
        templateThird
    }
})
export default class RgTemplate extends PaginationMixin {
    activeType: string = 'ordinary';

    @Watch('$route.name', { immediate: true })
    onRouterChange(name) {
        this.activeType = ROUTE_NAME_TO_TAB[name] || 'ordinary';
    }

    activeTypeChange(val) {
        this.$router
            .push({
                name: `rg_template_${val}`,
                query: {
                    rgId: `${this.rgId}`
                }
            })
            .catch(e => e);
    }

    get rgId() {
        return parseInt(this.$route.query.rgId as string, 10);
    }
}
